import { deleteQuestion } from "@/api/api";

export default {
  methods: {
    defaultQuestion: () => ({
      title: "Pronunciation",
      content: {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: "Write your word here ...",
              },
            ],
          },
        ],
      },
    }),
    onNewWord() {
      this.crud.question_group.questions.push(this.defaultQuestion());
    },
    removeQuestion(index) {
      const uuid = this.crud.question_group.questions[index].uuid;
      if (uuid) {
        deleteQuestion(uuid);
      }
      this.crud.question_group.questions.splice(index, 1);
    },
  },
};
